import { useState } from "react";
import { Search, SlidersHorizontal, RotateCcw } from "lucide-react";
import { Input } from "../ui/input";
import { STATUSES, emptyFilters } from "../../lib/adminApi";
import { RELIGIONS } from "../../lib/options";

const Sel = ({ label, value, onChange, options, testId }) => (
  <label className="space-y-1 text-xs font-medium text-[#8C6A6C]">
    {label}
    <select data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className="rmm-select rmm-input h-9 text-[#1A1515]">
      <option value="">All</option>
      {options.map((o) => <option key={o} value={o}>{o}</option>)}
    </select>
  </label>
);

const Txt = ({ label, value, onChange, testId, ...p }) => (
  <label className="space-y-1 text-xs font-medium text-[#8C6A6C]">
    {label}
    <Input data-testid={testId} value={value} onChange={(e) => onChange(e.target.value)} className="rmm-input h-9 bg-white text-[#1A1515]" {...p} />
  </label>
);

export function ProfileFilters({ value, onChange, hideStatus }) {
  const [open, setOpen] = useState(false);
  const set = (k) => (v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        <div className="relative min-w-[220px] flex-1">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-[#8C6A6C]" />
          <Input data-testid="filter-search-input" placeholder="Search name, registration no., phone or email" value={value.q} onChange={(e) => set("q")(e.target.value)} className="rmm-input h-10 bg-white pl-9" />
        </div>
        <button type="button" onClick={() => setOpen((o) => !o)} data-testid="filter-toggle-button" className="inline-flex items-center gap-1.5 rounded-full border border-[#D4AF37]/60 bg-white px-4 text-sm font-medium text-[#7A0016] hover:bg-[#F5E6BA]/50">
          <SlidersHorizontal className="h-4 w-4" /> Filters
        </button>
        <button type="button" onClick={() => onChange(emptyFilters)} data-testid="filter-reset-button" className="inline-flex items-center gap-1.5 rounded-full px-3 text-sm text-[#8C6A6C] hover:text-[#7A0016]">
          <RotateCcw className="h-4 w-4" /> Reset
        </button>
      </div>
      {open && (
        <div data-testid="filter-panel" className="grid grid-cols-2 gap-3 rounded-xl border border-[#D4AF37]/30 bg-white/80 p-4 sm:grid-cols-3 lg:grid-cols-6">
          {!hideStatus && <Sel label="Status" value={value.status} onChange={set("status")} options={STATUSES} testId="filter-status" />}
          <Sel label="Gender" value={value.gender} onChange={set("gender")} options={["male", "female"]} testId="filter-gender" />
          <Txt label="Age from" value={value.age_min} onChange={set("age_min")} inputMode="numeric" testId="filter-age-min" />
          <Txt label="Age to" value={value.age_max} onChange={set("age_max")} inputMode="numeric" testId="filter-age-max" />
          <Sel label="Religion" value={value.religion} onChange={set("religion")} options={RELIGIONS} testId="filter-religion" />
          <Txt label="Caste" value={value.caste} onChange={set("caste")} testId="filter-caste" />
          <Txt label="Education" value={value.education} onChange={set("education")} testId="filter-education" />
          <Txt label="City" value={value.city} onChange={set("city")} testId="filter-city" />
          <Txt label="Registered from" type="date" value={value.from} onChange={set("from")} testId="filter-date-from" />
          <Txt label="Registered to" type="date" value={value.to} onChange={set("to")} testId="filter-date-to" />
        </div>
      )}
    </div>
  );
}
